import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-guidance-detail',
    templateUrl: './common-guidance-detail.component.html',
    styleUrls: ['./common-guidance-detail.component.scss'],
    standalone: false
})
export class CommonGuidanceDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
